import { cn } from "@/common/utils/css.utils";

type HelpArticleBodyProps = {
  html: string;
  className?: string;
};

export const HelpArticleBody = ({ html, className }: HelpArticleBodyProps) => {
  return (
    <div
      className={cn(
        "prose max-w-none font-body text-grey-800 prose-headings:font-title prose-a:text-brand-500 prose-a:underline prose-img:max-w-full prose-img:rounded-[4px]",
        className
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
